import { useDeeplink } from '@hooks/deeplink';
import { cdnImageUrl } from '@utils/image';
import React from 'react';
import { MainFeedCellProps } from '.';

export const ButtonCategory: React.FC<{ item: any; style?: any }> = (props) => {
  const { item } = props;
  const { linkTo } = useDeeplink();
  return (
    <button
      className="link-button"
      style={{ alignItems: 'center', width: '64px', ...props.style }}
      onClick={() => {
        linkTo(item, { source: 'category-button' });
      }}>
      {item.imageUrl && item.imageUrl !== '' && (
        <img src={cdnImageUrl(item.imageUrl)} style={{ width: '48px', height: '48px', borderRadius: 0 }} alt="" />
      )}
      <div
        style={{
          alignItems: 'center',
          marginLeft: -1,
          height: '15px',
          justifyContent: 'flex-start',
        }}>
        <div style={{ fontSize: '12px', color: '#424242' }}>{item.categoryTitle}</div>
      </div>
    </button>
  );
};

export const CategoryCell: React.FC<MainFeedCellProps> = (props) => {
  const { data } = props;

  if (!data || data.length === 0) {
    return <div className="empty-category-cell"></div>;
  }

  return (
    <div
      id="category-cell-item"
      key={`splited-category`}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        width: '100%',
        padding: '0 16px',
        gap: '20px 0',
      }}>
      {data.map((category: any, index: number) => {
        return <ButtonCategory key={`category-${index}`} item={category} style={{ flexBasis: '20%' }}></ButtonCategory>;
      })}
    </div>
  );
};

export default CategoryCell;
